<div class="login-box">
    <div class="login-logo d-flex justify-content-center">
        <a href="../index2.html"><img src="/assets/images/globallab-logo-ma.png" class="mb-4" /></a>
    </div>
    <!-- /.login-logo -->
    <div class="card">
        <div class="card-body login-card-body">
            <p class="login-box-msg">Sign in to start your session</p>
            <form (submit)="onSubmit()" method="post">
                <div class="mb-3 field-loginform-username required">
                    <label class="form-label" for="loginform-username">Username</label>
                    <div class="input-group mb-3"><input type="text" id="loginform-username" class="form-control" name="username"
                            [(ngModel)]="username" aria-required="true">
                        <div class="input-group-text"><span class="bi bi-envelope"></span></div>
                    </div>
                    <div class="invalid-feedback"></div>
                </div>
                <div class="mb-3 field-loginform-password required">
                    <label class="form-label" for="loginform-password">Password</label>
                    <input type="password" id="loginform-password" class="form-control" name="password" [(ngModel)]="password" aria-required="true">

                    <div class="invalid-feedback"></div>
                </div>

                <!--begin::Row-->
                <div class="row">
                    <div class="col-7">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault"> Remember me </label>
                        </div>
                    </div>
                    <!-- /.col -->
                    <div class="col-5">
                        <div class="d-grid gap-2">
                            <button type="submit" class="btn btn-primary">Sign in</button>
                        </div>
                    </div>
                    <!-- /.col -->
                </div>
                <!--end::Row-->
            </form>
        </div>
        <!-- /.login-card-body -->
    </div>
</div>